// @flow
import React from "react";
import { connect } from "react-redux";
import cx from "classnames";
import glamorous from "glamorous";
import { createStructuredSelector } from "reselect";
import { consts as uploaderConsts } from "uploader";
import { selectPalette } from "root/selectors";
import t from "common/i18n";
import TabPanel from "tabs/hocs/TabPanel";
import TabFooter from "root/components/TabFooter";
import Button from "root/components/Button";
import SVG_ICONS from "~/assets/icons/icons";

import "./UrlTab.scss";

type Props = {
	addToUploadQueue: Function,
};

const GTitle = glamorous.div(cx("mb5 f2 bg-source-bg-c w-100"), {
	marginBottom: "22px",
	maxWidth: "628px",
});

const GSearchWrap = glamorous.div(cx("flex items-center relative overflow-hidden w-100"), {
	maxWidth: "628px",
});

const GInput = glamorous.input(cx("bc-link", "w-100 ba br1 f-5 pt4 pb4 pl5 pr8 outline-0 "), {
	color: "initial",
	paddingTop: 10,
	paddingBottom: 10,
	paddingLeft: 12,
	paddingRight: 44,
	height: "inherit",
});

const GButton = glamorous.div(cx("absolute"), {
	right: "1px",
	bottom: "0",
});

export class UrlTab extends React.Component<Props> {
	componentDidMount() {
		if (this.inputRef) {
			this.inputRef.focus();
		}
	}

	onInputKeyPress = (e: { which: number }) => {
		if (e.which === 13) {
			this.sendUrlToUpload();
		}
	};

	onUploadClick = () => {
		this.sendUrlToUpload();
	};

	inputRef = null;

	sendUrlToUpload() {
		if (this.inputRef) {
			this.props.addToUploadQueue({
				files: [this.inputRef.value],
			});
		}
	}

	render() {
		return <>
			<div
				className="holder large-thin-menu-holder flex flex-column justify-content-center items-center pl7 pr7 w-100">
				<GTitle>{t("url.inner_title")}</GTitle>
				<GSearchWrap>
					<GInput type="text" innerRef={(el) => this.inputRef = el}
					        onKeyPress={this.onInputKeyPress}
					        placeholder={t("url.input_placeholder")} data-test="search-input-box"/>
					<GButton>
						<Button colorName="link" dataTest="upload-from-link-btn"
						        icon={SVG_ICONS.ARROW_FORWARD}
						        onClick={this.onUploadClick}/>
					</GButton>
				</GSearchWrap>
			</div>
			<TabFooter/>
		</>;
	}
}

export default connect<Props, *, *, *, *, *>(
	createStructuredSelector({
		palette: selectPalette,
	}),
)(TabPanel({
	id: uploaderConsts.SOURCES.URL,
})(UrlTab));
